import C from "classnames";
import { isFunction } from "lodash";

const Checkbox = ({
  value,
  label = "",
  isReadOnly = false,
  onChange,
  className,
}) => {
  const onInputChange = () => {
    if (isReadOnly) {
      return;
    }

    if (isFunction(onChange)) {
      onChange(!value);
    }
  };

  return (
    <div className={C("form__checkbox", className)}>
      <input
        className="form__checkbox-input"
        type="checkbox"
        checked={value}
        disabled={isReadOnly}
        onChange={() => {
          onInputChange();
        }}
      />
      <label
        className="form__checkbox-label"
        onClick={() => {
          onInputChange();
        }}
      >
        <span>{label}</span>
      </label>
    </div>
  );
};

export { Checkbox };
